var tooltip = require('bootstrap-sass/assets/javascripts/bootstrap/tooltip');
var component = require('../../../lib/js/component.js');

function Tooltip() {
  this.initialize = function (element, options) {
    this.$element.tooltip();
  };
}
module.exports = component(Tooltip);
